<template>
  <div id="app">
    <AWGallery v-if="gallery"/>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import AWGallery from '@/components/Gallery'

export default {
  name: 'App',
  components   : {
    AWGallery
  },
  computed: {
    ...mapState([
      'gallery',
      'mobile',
      'selectedImage',
    ]),
  },
  mounted() {
    this.$store.dispatch('checkMobile');
    if(window.galleryId) {
      console.log('galleryID: ', window.galleryId);
      this.setGalleryId(window.galleryId);
    }

    this.loadGallery();
  },
  methods: {
    ...mapActions([
      'loadGallery',
    ]),
    ...mapMutations([
      'setGalleryId'
    ])
  }
}
</script>

<style scoped lang="scss">



</style>
